export default __webpack_public_path__ + "static/media/Investmentblack.7e78b66c.svg";